// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./fonts/Petersburg/Regular.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./fonts/Apertura/Regular.otf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --osc-brand-color: #008771;
  --osc-green-01: #DDF9F4;
  --osc-green-02: #98ECDE;
  --osc-green-03: #19B69C;
  --osc-green-04: #008771;
  --osc-green-05: #004154;
  --osc-green-06: #015143;
  --osc-green-07: #003028;
  --body-text: #1C3A49;
  --secondary-bg: #F0F6F9;
  --gray-01: #EFF7FB;
  --gray-02: #C4DAE3;
  --gray-03: #8AA0AA;
  --gray-04: #586C75;
  --gray-05: #28404B;
  --gray-06: #112E3D;
  --white: #FFFFFF;
  --black: #000;
  --success: #04D2A1;
  --error: #E81F5B;
  --star-size: 24px;
  --star-color: #FCBD06;
  --star-background: #C4DAE3;
  .xlSpacer {
    height: 124px;
  }
  .largeSpace {
    height: var(--4lg);
  }
  .mediumSpace {
    height: var(--2md);
  }
  .smallSpace {
    height: var(--4md);
  }
  --4sm: 8px;
  --3sm: 16px;
  --2sm: 24px;
  --sm: 32px;
  --4md: 40px;
  --3md: 48px;
  --2md: 56px;
  --md: 64px;
  --4lg: 72px;
  --3lg: 80px;
  --2lg: 88px;
  --lg: 96px;
}

/* TYPEOGRAPHY  */
@font-face {
  font-family: "Petersbug, Regular";
  src:
    url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("opentype")
}

@font-face {
  font-family: "Apertura, Regular";
  src:
    url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("opentype")
}

body {
  margin: 0;
  font-family: 'Apertura, Regular';
  font-size: 16px;
  line-height: 150%;
  text-align: center;
  width: 100%;
  box-sizing: border-box;
  background-color: var(--white);
}

.section {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

#child .section {
  padding: 0;
}

.tall, .short, .video {
  align-items: center;
}

h1 {
  font-size: 64px;
  line-height: 106.25%;
  font-family: 'Petersburg, Regular';
  font-weight: 400;
  font-style: normal;
  margin: 0;
}


h2 {
  line-height: 108.33%;
  font-family: 'Petersburg, Regular';
  font-style: normal;
  font-weight: 400;
  margin: 0;
}

h3 {
  font-size: 36px;
  line-height: 111.11%;
  font-family: 'Petersburg, Regular';
  font-weight: 400;
  margin: 0;
}

h4 {
  font-size: 26px;
  line-height: 120%;
  font-weight: 450;
  font-family: 'Apertura, Regular';
  margin: 0;
}

h5 {
  font-size: 20px;
  line-height: 150%;
  font-weight: 450;
  font-family: 'Apertura, Regular';
  letter-spacing: -0.05em;
  margin: 0;
}

h6 {
  font-size: 16px;
  line-height: 150%;
  font-family: 'Apertura, Regular';
  font-weight: 400;
  margin: 0;
}

p {
  margin: 0;
  font-family: 'Apertura, Regular';
}

p.allCaps {
  font-size: 0.875em;
  line-height: 142.857%;
  font-family: 'Apertura, Regular';
  font-weight: 450;
  text-transform: uppercase;
  letter-spacing: 0.0875em;
}
p.bodyText.twoColumn {
  color: var(--gray-05);
}
p.subtext {
  font-family: 'Apertura, Regular';;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
}

p.statText {
  font-family: 'Petersburg, Regular';
  font-size: 40px;
  font-style: normal;
  font-weight: 400;
  line-height: 120%;
  padding: 40px;
}

.statWhite {
  color: var(--white);
}

.statWhite.circle {
  background-color: var(--osc-brand-color);
  border-radius: 100px;
}

.statWhite.square {
  background-color: var(--osc-brand-color);
  border-radius: 2px;
}

.statGreen.circle {
  background-color: var(--white);
  border-radius: 100px;
}

.statGreen.square {
  background-color: var(--white);
  border-radius: 2px;
}

.statGreen {
  color: var(--osc-brand-color)
}

/* Large desktop  */
@media (min-width: 1280px) {
  .section {
    padding: var(--lg) 120px;
  }
  .short {
    height: 472px;
  }
  .tall {
    height: 650px;
  }
  .standard {
    gap: var(--3sm);
  }
  .large {
    gap: var(--2sm) var(--lg);
  }
  .huge {
    gap: 124px;
  }
  .lots {
    gap: var(--md);
  }
  .regular {
    gap: var(--3md)
  }
  .medium {
    gap: var(--2lg);
  }
  .some {
    gap: var(--4md);
  }
  .small {
    gap: var(--sm);
  }
  .tiny {
    gap: var(--2sm)
  }
  .xlSpacer {
    height: 124px;
  }
  .largeSpace {
    height: var(--4lg);
  }
  .mediumSpace {
    height: var(--2md);
  }
  .smallSpace {
    height: var(--4md);
  }
  .video {
    height: 824px;
  }
  .hero .play {
    margin-top: 288px;
  }
  .statBlock {
    padding: var(--4md);
  }
  .statDescription {
    max-width: 276px;
  }
  p {
    font-size: 20px;
    line-height: 150%;
  }
  p.ratings-block-text {
    max-width: 276px;
  }
  p.bodyText {
    font-family: 'Apertura, Regular';
    font-size: 20px;
    line-height: 150%;
  }
  h1 {
    font-size: 64px;
  }
  h2 {
    font-size: 48px;
  }
  button {
    width: auto;
  }
}

/* Small desktop  */
@media (max-width: 1279px) {
  .section {
    padding: var(--lg) 60px;
  }
  .short {
    height: 472px;
  }
  .tall {
    height: 650px;
  }  
  .standard {
    gap: var(--3sm);
  }
  .huge {
    gap: 124px;
  }
  .large {
    gap: var(--2sm) var(--lg);
  }
  .lots {
    gap: var(--md);
  }
  .regular {
    gap: var(--3md)
  }
  .medium {
    gap: var(--2lg);
  }
  .some {
    gap: var(--4md);
  }
  .small {
    gap: var(--sm);
  }
  .tiny {
    gap: var(--2sm)
  }
  .xlSpacer {
    height: 124px;
  }
  .largeSpace {
    height: var(--4lg);
  }
  .mediumSpace {
    height: var(--2md);
  }
  .smallSpace {
    height: var(--4md);
  }
  .video {
    height: 824px;
  }
  .hero .play {
    margin-top: 288px;
  }
  .statBlock {
    padding: var(--4md);
  }
  .statDescription {
    max-width: 276px;
  }
  p {
    font-size: 20px;
    line-height: 150%;
  }
  p.ratings-block-text {
    max-width: 276px;
  }
  p.bodyText {
    font-family: 'Apertura, Regular';
    font-size: 20px;
    line-height: 150%;
  }
  h1 {
    font-size: 64px;
  }
  h2 {
    font-size: 48px;
  }
  button {
    width: auto;
  }
}

/* Tablet  */
@media (max-width: 1023px) {
  .section {
    padding: var(--2md) var(--sm);
  }
  .short, .tall {
    height: 400px;
  }
  .standard {
    gap: var(--3sm);
  }
  .huge {
    gap: 124px;
  }
  .large {
    gap: var(--2sm) var(--2lg);
  }
  .lots {
    gap: var(--3md);
  }
  .regular {
    gap: var(--3md)
  }
  .medium {
    gap: var(--3md);
  }
  .some {
    gap: var(--2sm);
  }
  .small {
    gap: var(--sm);
  }
  .tiny {
    gap: var(--2sm)
  }
  .xlSpacer {
    height: 124px;
  }
  .largeSpace {
    height: var(--4lg);
  }
  .mediumSpace {
    height: var(--2md);
  }
  .smallSpace {
    height: var(--4md);
  }
  .video {
    height: 472px;
  }
  .hero .play {
    margin-top: 288px;
  }
  .play {
    height: 64px;
    width: 64px;
  }
  .statBlock {
    padding: var(--2sm);
  }
  .statDescription {
    max-width: 500px;
  }
  p {
    font-size: 18px;
    line-height: 150%;
  }
  p.ratings-block-text {
    max-width: 500px;
  }
  p.bodyText {
    font-family: 'Apertura, Regular';
    font-size: 16px;
    line-height: 150%;
  }
  h1 {
    font-size: 48px;
  }
  h2 {
    font-size: 36px;
  }
  button {
    width: auto;
  }
}

/* Mobile  */
@media (max-width: 600px) {
  .section {
    padding: var(--3md) 20px;
  }
  .short, .tall {
    height: 350px;
  }
  .standard {
    gap: var(--3sm);
  }
  .large {
    gap: var(--2sm);
  }
  .huge {
    gap: var(--lg);
  }
  .lots {
    gap: var(--sm);
  }
  .regular {
    gap: var(--3md)
  }
  .medium {
    gap: var(--4md);
  }
  .some {
    gap: var(--2sm);
  }
  .small {
    gap: var(--sm);
  }
  .tiny {
    gap: var(--2sm)
  }
  .none {
    gap: 0;
  }
  .xlSpacer {
    height: var(--lg);
  }
  .largeSpace {
    height: var(--2md);
  }
  .mediumSpace {
    height: var(--4md);
  }
  .smallSpace {
    height: var(--2sm);
  }
  .video {
    height: 472px;
  }
  .hero .play {
    margin-top: 320px;
  }
  .play {
    height: 64px;
    width: 64px;
  }
  .statBlock {
    padding: var(--2sm);
  }
  p {
    font-size: 16px;
    line-height: 150%;
  }
  p.ratings-block-text {
    max-width: 287px;
  }
  p.bodyText {
    font-family: 'Apertura, Regular';
    font-size: 16px;
    line-height: 150%;
  }
  h1 {
    font-size: 36px;
  }
  h2 {
    font-size: 30px;
  }
  button {
    width: 100%;
    text-wrap: wrap;
  }
}

.App {
  background-color: var(--white);
  text-align: center;
  align-items: center;
}

a {
  text-decoration: underline;
}

button a {
  text-decoration: none;
}

a:hover {
  text-decoration: underline;
}

button a:hover {
  text-decoration: none;
}

button.transparent a:hover {
  text-decoration: underline;
}

a#side-nav {
    transition: color 0.2s;
}

a#side-nav:hover {
  font-weight: bold;
  transition: color 0.2s;
}

button {
  font-size: 15px;
  vertical-align: middle;
  font-family: 'Apertura, Regular';
  letter-spacing: 0.046875em;
  text-transform: uppercase;
  font-weight: 450;
  border-radius: 0.125em;
  border: solid 0.0625em;
  padding: 10px var(--3sm);
  padding-Top: 14px;
}

button.greenbtn {
  background-color: var(--osc-brand-color);
  border-color: var(--osc-brand-color);
  color: var(--white);
}

button.greenbtn:hover {
  background-color: var(--osc-green-06);
}


button.greenbtn:disabled {
  border: 3px solid #B2DBD4;
}

button.greenbtn a {
  color: var(--white);
}

button.whitebtn {
  background-color: var(--white);
  border-color: var(--gray-06);
  color: var(--gray-06);
}

button.whitebtn a {
  color: var(--gray-06);
}

button.whitebtn:hover {
  background-color: var(--gray-06);
  color: var(--white);
}

button.whitebtn:hover .link-text  {
  color: var(--white);
}

.back-arrow-svg .back-arrow-path {
  stroke: var(--gray-06);
}

button.whitebtn:hover .back-arrow-svg .back-arrow-path {
stroke: var(--white);
}

button.transparentbtn {
  background-color: transparent;
  color: var(--osc-brand-color);
  border-color: transparent;
}

button.transparentbtn a {
  background-color: transparent;
  color: var(--osc-brand-color);
  border-color: transparent;
}

.stars {
  --percent: calc(var(--stars)/5 * 100%);
  display: inline-block;
  font-size: var(--star-size);
  font-family: Times;
  line-height: 1;
  &::before {
    content: '★★★★★';
    letter-spacing: 3px;
    background: linear-gradient(90deg, var(--star-color) var(--percent), var(--star-background) var(--percent));
    -webkit-background-clip: text;
            background-clip: text;
    -webkit-text-fill-color: transparent;
  }
}

/* COLORS  */

.lightblue {
  background-color: var(--gray-01);
  color: var(--gray-06);
}

.lightblue a {
  color: var(--osc-green-04);
}

.white {
  background-color: var(--white);
  color: var(--gray-06);
}

.white a {
  color: var(--osc-green-04);
}

.lightgreen {
  background-color: var(--osc-green-01);
  color: var(--osc-green-06);
}

.lightgreen h3, .lightgreen h2 {
  color: var(--osc-green-07);
}

.lightgreen p, .lightgreen li {
  color: var(--osc-green-06);
}

li {
  margin-left: 20px;
}

.image-wrapper {
  overflow: hidden;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
}

.image-container {
  position: relative;
}

.overlay-text {
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  color: var(--white);
  width: var(--2md);
  height: var(--2md);
  border-radius: 2px;
  text-align: center;
  font-family: "Apertura, Regular";
}

.image-wrapper img {
  width: 100%; 
  height: 100%; 
  object-fit: cover; 
  object-position: center center; 
}

.OneColumn {
  display: flex;
  flex-direction: column;
}

/* SCROLL BAR */

div::-webkit-scrollbar {
  background-color: var(--gray-02);
  border-radius: 50px;
}

div::-webkit-scrollbar:horizontal {
  height: var(--4sm);
}

div::-webkit-scrollbar:vertical {
  width: var(--4sm);
}

div::-webkit-scrollbar-thumb {
  background-color: var(--osc-brand-color);
  border-radius: 50px;
}

/* div.testimonial-block::-webkit-scrollbar-thumb {
  z-index: 10;
} */

div::-webkit-scrollbar-track {
  background-color: var(--gray-02);
  border-radius: 0.25em;
}

.smooth-scroll {
  transition: scroll-behavior 0.5s ease-in-out;
}

.testimonial {
  opacity: 0;
  transition: opacity 0.5s ease-in-out;
}

.fade-in {
  opacity: 1;
}

.fade-out {
  opacity: 0;
}

.tab svg.accordion-carrot {
  stroke: var(--gray-06);
  height: var(--2sm);
  width: var(--2sm);
}

`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,0BAA0B;EAC1B,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,oBAAoB;EACpB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;EACrB,0BAA0B;EAC1B;IACE,aAAa;EACf;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA,UAAU;EACV,WAAW;EACX,WAAW;EACX,UAAU;EACV,WAAW;EACX,WAAW;EACX,WAAW;EACX,UAAU;EACV,WAAW;EACX,WAAW;EACX,WAAW;EACX,UAAU;AACZ;;AAEA,iBAAiB;AACjB;EACE,iCAAiC;EACjC;;AAEF;;AAEA;EACE,gCAAgC;EAChC;;AAEF;;AAEA;EACE,SAAS;EACT,gCAAgC;EAChC,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,oBAAoB;EACpB,kCAAkC;EAClC,gBAAgB;EAChB,kBAAkB;EAClB,SAAS;AACX;;;AAGA;EACE,oBAAoB;EACpB,kCAAkC;EAClC,kBAAkB;EAClB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,oBAAoB;EACpB,kCAAkC;EAClC,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,gCAAgC;EAChC,SAAS;AACX;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,gCAAgC;EAChC,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gCAAgC;EAChC,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,SAAS;EACT,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,gCAAgC;EAChC,gBAAgB;EAChB,yBAAyB;EACzB,wBAAwB;AAC1B;AACA;EACE,qBAAqB;AACvB;AACA;EACE,gCAAgC;EAChC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kCAAkC;EAClC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,wCAAwC;EACxC,oBAAoB;AACtB;;AAEA;EACE,wCAAwC;EACxC,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;EAC9B,oBAAoB;AACtB;;AAEA;EACE,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE;AACF;;AAEA,mBAAmB;AACnB;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,eAAe;EACjB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,UAAU;EACZ;EACA;IACE,cAAc;EAChB;EACA;IACE;EACF;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,cAAc;EAChB;EACA;IACE;EACF;EACA;IACE,aAAa;EACf;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,aAAa;EACf;EACA;IACE,iBAAiB;EACnB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gCAAgC;IAChC,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,WAAW;EACb;AACF;;AAEA,mBAAmB;AACnB;EACE;IACE,uBAAuB;EACzB;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,eAAe;EACjB;EACA;IACE,UAAU;EACZ;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,cAAc;EAChB;EACA;IACE;EACF;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,cAAc;EAChB;EACA;IACE;EACF;EACA;IACE,aAAa;EACf;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,aAAa;EACf;EACA;IACE,iBAAiB;EACnB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gCAAgC;IAChC,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,WAAW;EACb;AACF;;AAEA,YAAY;AACZ;EACE;IACE,6BAA6B;EAC/B;EACA;IACE,aAAa;EACf;EACA;IACE,eAAe;EACjB;EACA;IACE,UAAU;EACZ;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,eAAe;EACjB;EACA;IACE;EACF;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,cAAc;EAChB;EACA;IACE;EACF;EACA;IACE,aAAa;EACf;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,aAAa;EACf;EACA;IACE,iBAAiB;EACnB;EACA;IACE,YAAY;IACZ,WAAW;EACb;EACA;IACE,mBAAmB;EACrB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gCAAgC;IAChC,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,WAAW;EACb;AACF;;AAEA,YAAY;AACZ;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,aAAa;EACf;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,cAAc;EAChB;EACA;IACE,cAAc;EAChB;EACA;IACE;EACF;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,cAAc;EAChB;EACA;IACE;EACF;EACA;IACE,MAAM;EACR;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,aAAa;EACf;EACA;IACE,iBAAiB;EACnB;EACA;IACE,YAAY;IACZ,WAAW;EACb;EACA;IACE,mBAAmB;EACrB;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gCAAgC;IAChC,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,WAAW;IACX,eAAe;EACjB;AACF;;AAEA;EACE,8BAA8B;EAC9B,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,gCAAgC;EAChC,0BAA0B;EAC1B,yBAAyB;EACzB,gBAAgB;EAChB,sBAAsB;EACtB,sBAAsB;EACtB,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;EACE,wCAAwC;EACxC,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;AACvC;;;AAGA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,4BAA4B;EAC5B,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;AACA,oBAAoB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;EAC7B,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;EACE,sCAAsC;EACtC,qBAAqB;EACrB,2BAA2B;EAC3B,kBAAkB;EAClB,cAAc;EACd;IACE,gBAAgB;IAChB,mBAAmB;IACnB,2GAA2G;IAC3G,6BAAqB;YAArB,qBAAqB;IACrB,oCAAoC;EACtC;AACF;;AAEA,YAAY;;AAEZ;EACE,gCAAgC;EAChC,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,8BAA8B;EAC9B,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,qCAAqC;EACrC,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA,eAAe;;AAEf;EACE,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,wCAAwC;EACxC,mBAAmB;AACrB;;AAEA;;GAEG;;AAEH;EACE,gCAAgC;EAChC,qBAAqB;AACvB;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,UAAU;EACV,oCAAoC;AACtC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;AACnB","sourcesContent":[":root {\n  --osc-brand-color: #008771;\n  --osc-green-01: #DDF9F4;\n  --osc-green-02: #98ECDE;\n  --osc-green-03: #19B69C;\n  --osc-green-04: #008771;\n  --osc-green-05: #004154;\n  --osc-green-06: #015143;\n  --osc-green-07: #003028;\n  --body-text: #1C3A49;\n  --secondary-bg: #F0F6F9;\n  --gray-01: #EFF7FB;\n  --gray-02: #C4DAE3;\n  --gray-03: #8AA0AA;\n  --gray-04: #586C75;\n  --gray-05: #28404B;\n  --gray-06: #112E3D;\n  --white: #FFFFFF;\n  --black: #000;\n  --success: #04D2A1;\n  --error: #E81F5B;\n  --star-size: 24px;\n  --star-color: #FCBD06;\n  --star-background: #C4DAE3;\n  .xlSpacer {\n    height: 124px;\n  }\n  .largeSpace {\n    height: var(--4lg);\n  }\n  .mediumSpace {\n    height: var(--2md);\n  }\n  .smallSpace {\n    height: var(--4md);\n  }\n  --4sm: 8px;\n  --3sm: 16px;\n  --2sm: 24px;\n  --sm: 32px;\n  --4md: 40px;\n  --3md: 48px;\n  --2md: 56px;\n  --md: 64px;\n  --4lg: 72px;\n  --3lg: 80px;\n  --2lg: 88px;\n  --lg: 96px;\n}\n\n/* TYPEOGRAPHY  */\n@font-face {\n  font-family: \"Petersbug, Regular\";\n  src:\n    url(\"./fonts/Petersburg/Regular.otf\") format(\"opentype\")\n}\n\n@font-face {\n  font-family: \"Apertura, Regular\";\n  src:\n    url(\"./fonts/Apertura/Regular.otf\") format(\"opentype\")\n}\n\nbody {\n  margin: 0;\n  font-family: 'Apertura, Regular';\n  font-size: 16px;\n  line-height: 150%;\n  text-align: center;\n  width: 100%;\n  box-sizing: border-box;\n  background-color: var(--white);\n}\n\n.section {\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n}\n\n#child .section {\n  padding: 0;\n}\n\n.tall, .short, .video {\n  align-items: center;\n}\n\nh1 {\n  font-size: 64px;\n  line-height: 106.25%;\n  font-family: 'Petersburg, Regular';\n  font-weight: 400;\n  font-style: normal;\n  margin: 0;\n}\n\n\nh2 {\n  line-height: 108.33%;\n  font-family: 'Petersburg, Regular';\n  font-style: normal;\n  font-weight: 400;\n  margin: 0;\n}\n\nh3 {\n  font-size: 36px;\n  line-height: 111.11%;\n  font-family: 'Petersburg, Regular';\n  font-weight: 400;\n  margin: 0;\n}\n\nh4 {\n  font-size: 26px;\n  line-height: 120%;\n  font-weight: 450;\n  font-family: 'Apertura, Regular';\n  margin: 0;\n}\n\nh5 {\n  font-size: 20px;\n  line-height: 150%;\n  font-weight: 450;\n  font-family: 'Apertura, Regular';\n  letter-spacing: -0.05em;\n  margin: 0;\n}\n\nh6 {\n  font-size: 16px;\n  line-height: 150%;\n  font-family: 'Apertura, Regular';\n  font-weight: 400;\n  margin: 0;\n}\n\np {\n  margin: 0;\n  font-family: 'Apertura, Regular';\n}\n\np.allCaps {\n  font-size: 0.875em;\n  line-height: 142.857%;\n  font-family: 'Apertura, Regular';\n  font-weight: 450;\n  text-transform: uppercase;\n  letter-spacing: 0.0875em;\n}\np.bodyText.twoColumn {\n  color: var(--gray-05);\n}\np.subtext {\n  font-family: 'Apertura, Regular';;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 150%;\n}\n\np.statText {\n  font-family: 'Petersburg, Regular';\n  font-size: 40px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 120%;\n  padding: 40px;\n}\n\n.statWhite {\n  color: var(--white);\n}\n\n.statWhite.circle {\n  background-color: var(--osc-brand-color);\n  border-radius: 100px;\n}\n\n.statWhite.square {\n  background-color: var(--osc-brand-color);\n  border-radius: 2px;\n}\n\n.statGreen.circle {\n  background-color: var(--white);\n  border-radius: 100px;\n}\n\n.statGreen.square {\n  background-color: var(--white);\n  border-radius: 2px;\n}\n\n.statGreen {\n  color: var(--osc-brand-color)\n}\n\n/* Large desktop  */\n@media (min-width: 1280px) {\n  .section {\n    padding: var(--lg) 120px;\n  }\n  .short {\n    height: 472px;\n  }\n  .tall {\n    height: 650px;\n  }\n  .standard {\n    gap: var(--3sm);\n  }\n  .large {\n    gap: var(--2sm) var(--lg);\n  }\n  .huge {\n    gap: 124px;\n  }\n  .lots {\n    gap: var(--md);\n  }\n  .regular {\n    gap: var(--3md)\n  }\n  .medium {\n    gap: var(--2lg);\n  }\n  .some {\n    gap: var(--4md);\n  }\n  .small {\n    gap: var(--sm);\n  }\n  .tiny {\n    gap: var(--2sm)\n  }\n  .xlSpacer {\n    height: 124px;\n  }\n  .largeSpace {\n    height: var(--4lg);\n  }\n  .mediumSpace {\n    height: var(--2md);\n  }\n  .smallSpace {\n    height: var(--4md);\n  }\n  .video {\n    height: 824px;\n  }\n  .hero .play {\n    margin-top: 288px;\n  }\n  .statBlock {\n    padding: var(--4md);\n  }\n  .statDescription {\n    max-width: 276px;\n  }\n  p {\n    font-size: 20px;\n    line-height: 150%;\n  }\n  p.ratings-block-text {\n    max-width: 276px;\n  }\n  p.bodyText {\n    font-family: 'Apertura, Regular';\n    font-size: 20px;\n    line-height: 150%;\n  }\n  h1 {\n    font-size: 64px;\n  }\n  h2 {\n    font-size: 48px;\n  }\n  button {\n    width: auto;\n  }\n}\n\n/* Small desktop  */\n@media (max-width: 1279px) {\n  .section {\n    padding: var(--lg) 60px;\n  }\n  .short {\n    height: 472px;\n  }\n  .tall {\n    height: 650px;\n  }  \n  .standard {\n    gap: var(--3sm);\n  }\n  .huge {\n    gap: 124px;\n  }\n  .large {\n    gap: var(--2sm) var(--lg);\n  }\n  .lots {\n    gap: var(--md);\n  }\n  .regular {\n    gap: var(--3md)\n  }\n  .medium {\n    gap: var(--2lg);\n  }\n  .some {\n    gap: var(--4md);\n  }\n  .small {\n    gap: var(--sm);\n  }\n  .tiny {\n    gap: var(--2sm)\n  }\n  .xlSpacer {\n    height: 124px;\n  }\n  .largeSpace {\n    height: var(--4lg);\n  }\n  .mediumSpace {\n    height: var(--2md);\n  }\n  .smallSpace {\n    height: var(--4md);\n  }\n  .video {\n    height: 824px;\n  }\n  .hero .play {\n    margin-top: 288px;\n  }\n  .statBlock {\n    padding: var(--4md);\n  }\n  .statDescription {\n    max-width: 276px;\n  }\n  p {\n    font-size: 20px;\n    line-height: 150%;\n  }\n  p.ratings-block-text {\n    max-width: 276px;\n  }\n  p.bodyText {\n    font-family: 'Apertura, Regular';\n    font-size: 20px;\n    line-height: 150%;\n  }\n  h1 {\n    font-size: 64px;\n  }\n  h2 {\n    font-size: 48px;\n  }\n  button {\n    width: auto;\n  }\n}\n\n/* Tablet  */\n@media (max-width: 1023px) {\n  .section {\n    padding: var(--2md) var(--sm);\n  }\n  .short, .tall {\n    height: 400px;\n  }\n  .standard {\n    gap: var(--3sm);\n  }\n  .huge {\n    gap: 124px;\n  }\n  .large {\n    gap: var(--2sm) var(--2lg);\n  }\n  .lots {\n    gap: var(--3md);\n  }\n  .regular {\n    gap: var(--3md)\n  }\n  .medium {\n    gap: var(--3md);\n  }\n  .some {\n    gap: var(--2sm);\n  }\n  .small {\n    gap: var(--sm);\n  }\n  .tiny {\n    gap: var(--2sm)\n  }\n  .xlSpacer {\n    height: 124px;\n  }\n  .largeSpace {\n    height: var(--4lg);\n  }\n  .mediumSpace {\n    height: var(--2md);\n  }\n  .smallSpace {\n    height: var(--4md);\n  }\n  .video {\n    height: 472px;\n  }\n  .hero .play {\n    margin-top: 288px;\n  }\n  .play {\n    height: 64px;\n    width: 64px;\n  }\n  .statBlock {\n    padding: var(--2sm);\n  }\n  .statDescription {\n    max-width: 500px;\n  }\n  p {\n    font-size: 18px;\n    line-height: 150%;\n  }\n  p.ratings-block-text {\n    max-width: 500px;\n  }\n  p.bodyText {\n    font-family: 'Apertura, Regular';\n    font-size: 16px;\n    line-height: 150%;\n  }\n  h1 {\n    font-size: 48px;\n  }\n  h2 {\n    font-size: 36px;\n  }\n  button {\n    width: auto;\n  }\n}\n\n/* Mobile  */\n@media (max-width: 600px) {\n  .section {\n    padding: var(--3md) 20px;\n  }\n  .short, .tall {\n    height: 350px;\n  }\n  .standard {\n    gap: var(--3sm);\n  }\n  .large {\n    gap: var(--2sm);\n  }\n  .huge {\n    gap: var(--lg);\n  }\n  .lots {\n    gap: var(--sm);\n  }\n  .regular {\n    gap: var(--3md)\n  }\n  .medium {\n    gap: var(--4md);\n  }\n  .some {\n    gap: var(--2sm);\n  }\n  .small {\n    gap: var(--sm);\n  }\n  .tiny {\n    gap: var(--2sm)\n  }\n  .none {\n    gap: 0;\n  }\n  .xlSpacer {\n    height: var(--lg);\n  }\n  .largeSpace {\n    height: var(--2md);\n  }\n  .mediumSpace {\n    height: var(--4md);\n  }\n  .smallSpace {\n    height: var(--2sm);\n  }\n  .video {\n    height: 472px;\n  }\n  .hero .play {\n    margin-top: 320px;\n  }\n  .play {\n    height: 64px;\n    width: 64px;\n  }\n  .statBlock {\n    padding: var(--2sm);\n  }\n  p {\n    font-size: 16px;\n    line-height: 150%;\n  }\n  p.ratings-block-text {\n    max-width: 287px;\n  }\n  p.bodyText {\n    font-family: 'Apertura, Regular';\n    font-size: 16px;\n    line-height: 150%;\n  }\n  h1 {\n    font-size: 36px;\n  }\n  h2 {\n    font-size: 30px;\n  }\n  button {\n    width: 100%;\n    text-wrap: wrap;\n  }\n}\n\n.App {\n  background-color: var(--white);\n  text-align: center;\n  align-items: center;\n}\n\na {\n  text-decoration: underline;\n}\n\nbutton a {\n  text-decoration: none;\n}\n\na:hover {\n  text-decoration: underline;\n}\n\nbutton a:hover {\n  text-decoration: none;\n}\n\nbutton.transparent a:hover {\n  text-decoration: underline;\n}\n\na#side-nav {\n    transition: color 0.2s;\n}\n\na#side-nav:hover {\n  font-weight: bold;\n  transition: color 0.2s;\n}\n\nbutton {\n  font-size: 15px;\n  vertical-align: middle;\n  font-family: 'Apertura, Regular';\n  letter-spacing: 0.046875em;\n  text-transform: uppercase;\n  font-weight: 450;\n  border-radius: 0.125em;\n  border: solid 0.0625em;\n  padding: 10px var(--3sm);\n  padding-Top: 14px;\n}\n\nbutton.greenbtn {\n  background-color: var(--osc-brand-color);\n  border-color: var(--osc-brand-color);\n  color: var(--white);\n}\n\nbutton.greenbtn:hover {\n  background-color: var(--osc-green-06);\n}\n\n\nbutton.greenbtn:disabled {\n  border: 3px solid #B2DBD4;\n}\n\nbutton.greenbtn a {\n  color: var(--white);\n}\n\nbutton.whitebtn {\n  background-color: var(--white);\n  border-color: var(--gray-06);\n  color: var(--gray-06);\n}\n\nbutton.whitebtn a {\n  color: var(--gray-06);\n}\n\nbutton.whitebtn:hover {\n  background-color: var(--gray-06);\n  color: var(--white);\n}\n\nbutton.whitebtn:hover .link-text  {\n  color: var(--white);\n}\n\n.back-arrow-svg .back-arrow-path {\n  stroke: var(--gray-06);\n}\n\nbutton.whitebtn:hover .back-arrow-svg .back-arrow-path {\nstroke: var(--white);\n}\n\nbutton.transparentbtn {\n  background-color: transparent;\n  color: var(--osc-brand-color);\n  border-color: transparent;\n}\n\nbutton.transparentbtn a {\n  background-color: transparent;\n  color: var(--osc-brand-color);\n  border-color: transparent;\n}\n\n.stars {\n  --percent: calc(var(--stars)/5 * 100%);\n  display: inline-block;\n  font-size: var(--star-size);\n  font-family: Times;\n  line-height: 1;\n  &::before {\n    content: '★★★★★';\n    letter-spacing: 3px;\n    background: linear-gradient(90deg, var(--star-color) var(--percent), var(--star-background) var(--percent));\n    background-clip: text;\n    -webkit-text-fill-color: transparent;\n  }\n}\n\n/* COLORS  */\n\n.lightblue {\n  background-color: var(--gray-01);\n  color: var(--gray-06);\n}\n\n.lightblue a {\n  color: var(--osc-green-04);\n}\n\n.white {\n  background-color: var(--white);\n  color: var(--gray-06);\n}\n\n.white a {\n  color: var(--osc-green-04);\n}\n\n.lightgreen {\n  background-color: var(--osc-green-01);\n  color: var(--osc-green-06);\n}\n\n.lightgreen h3, .lightgreen h2 {\n  color: var(--osc-green-07);\n}\n\n.lightgreen p, .lightgreen li {\n  color: var(--osc-green-06);\n}\n\nli {\n  margin-left: 20px;\n}\n\n.image-wrapper {\n  overflow: hidden;\n  position: relative;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.image-container {\n  position: relative;\n}\n\n.overlay-text {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: absolute;\n  color: var(--white);\n  width: var(--2md);\n  height: var(--2md);\n  border-radius: 2px;\n  text-align: center;\n  font-family: \"Apertura, Regular\";\n}\n\n.image-wrapper img {\n  width: 100%; \n  height: 100%; \n  object-fit: cover; \n  object-position: center center; \n}\n\n.OneColumn {\n  display: flex;\n  flex-direction: column;\n}\n\n/* SCROLL BAR */\n\ndiv::-webkit-scrollbar {\n  background-color: var(--gray-02);\n  border-radius: 50px;\n}\n\ndiv::-webkit-scrollbar:horizontal {\n  height: var(--4sm);\n}\n\ndiv::-webkit-scrollbar:vertical {\n  width: var(--4sm);\n}\n\ndiv::-webkit-scrollbar-thumb {\n  background-color: var(--osc-brand-color);\n  border-radius: 50px;\n}\n\n/* div.testimonial-block::-webkit-scrollbar-thumb {\n  z-index: 10;\n} */\n\ndiv::-webkit-scrollbar-track {\n  background-color: var(--gray-02);\n  border-radius: 0.25em;\n}\n\n.smooth-scroll {\n  transition: scroll-behavior 0.5s ease-in-out;\n}\n\n.testimonial {\n  opacity: 0;\n  transition: opacity 0.5s ease-in-out;\n}\n\n.fade-in {\n  opacity: 1;\n}\n\n.fade-out {\n  opacity: 0;\n}\n\n.tab svg.accordion-carrot {\n  stroke: var(--gray-06);\n  height: var(--2sm);\n  width: var(--2sm);\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
